import { WEDDING_DATE_SET, PRECEPTION_DATE_SET } from '../actions/actionTypes';

export default (state = {}, action) => {
  switch (action.type) {
    case WEDDING_DATE_SET:
      return {
        ...state,
        weddingDate: action.payload
      };
      case PRECEPTION_DATE_SET:
      return {
        ...state,
        preceptionDate: action.payload
      };
    default:
      return state;
  }
};


// WEBPACK FOOTER //
// ./src/reducers/dates.js